import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/sections/HeroSection";
import ProblemSolutionSection from "@/components/sections/ProblemSolutionSection";
import BeforeAfterSection from "@/components/sections/BeforeAfterSection";
import WhoWeServeSection from "@/components/sections/WhoWeServeSection";
import CoreServicesSection from "@/components/sections/CoreServicesSection";
import WorkflowSection from "@/components/sections/WorkflowSection";
import ProvidersGainSection from "@/components/sections/ProvidersGainSection";
import TrustSection from "@/components/sections/TrustSection";
import FinalCTASection from "@/components/sections/FinalCTASection";
import Footer from "@/components/Footer";

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [demoRequested, setDemoRequested] = useState(false);

  useEffect(() => {
    // Check if navigated with demo request
    if (location.state?.requestDemo) {
      setDemoRequested(true);
      navigate("/contact", { state: { requestDemo: true } });
    }
  }, [location, navigate]);

  const handleScheduleDemo = () => {
    navigate("/contact", { state: { requestDemo: true } });
  };

  const handleContactUs = () => {
    navigate("/contact");
  };

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#0A0A0A]">
      <Header onScheduleDemo={handleScheduleDemo} onContactUs={handleContactUs} />
      
      <main>
        <HeroSection onScheduleDemo={handleScheduleDemo} onContactUs={handleContactUs} />
        
        <div className="ecg-line" />
        <ProblemSolutionSection />
        
        <div className="ecg-line" />
        <BeforeAfterSection />
        
        <div className="ecg-line" />
        <WhoWeServeSection />
        
        <div className="ecg-line" />
        <CoreServicesSection />
        
        <div className="ecg-line" />
        <WorkflowSection />
        
        <div className="ecg-line" />
        <ProvidersGainSection />
        
        <div className="ecg-line" />
        <TrustSection />
        
        <div className="ecg-line" />
        <FinalCTASection onScheduleDemo={handleScheduleDemo} onContactUs={handleContactUs} />
      </main>
      
      <Footer />
    </div>
  );
};

export default HomePage;
